module.exports = __webpack_public_path__ + "static/2-0f56c8b7ad33fd525e0870dfb01521d0.jpg";